import React from 'react'
import resolveProps from '../../../utils/resolveProps'
import { LinkProps } from './types'
const config = {
  types: [
    {
      title: 'default',
      isDefault: true
    },
    'arrow',
    'icon'
  ],
  modifiers: ['inverse'],
  states: []
}

export default function Link(props: LinkProps) {
  const { href, target, tag, children, inverse, arrow, icon, iconName, className = '', type, gtm = {}, onClick, ...rest } = props
  const { gtmClassName = '', dataGTM = {} } = gtm

  const CustomTag = tag || 'a'

  return !arrow
    ? <div className={`${resolveProps(props, config, 'Link')}`} >
    <CustomTag {...rest} className={`mdn-Link-anchor ${gtmClassName}`} href={href} target={target} onClick={onClick} type={type} {...dataGTM}>
    <span className={"mdn-Icon-" + iconName + " mdn-Icon--md"}></span>
    <span className="mdn-Link-anchor-label">{children}</span>
    </CustomTag>
  </div>
    : !icon ? (
      <div className={`${resolveProps(props, config, 'Link')}`} >
        <CustomTag {...rest} className={`mdn-Link-anchor ${gtmClassName}`} href={href} target={target} onClick={onClick} type={type} {...dataGTM}>
          <span className="mdn-Link-anchor-label">{children}</span>
          <span className={'mdn-Link-anchor-icon mdn-Icon-direita mdn-Icon--sm'}></span >
        </CustomTag>
      </div>
    ) : (
      <CustomTag className={`${resolveProps(props, config, 'Link')} mdn-Link-anchor ${gtmClassName}`} href={href} target={target} {...dataGTM} onClick={onClick} {...rest} type={type} >{children}</CustomTag>
    )
}
